import { getOfferApy } from "../EarnOffer";
import Big from "big.js";
import { useAtomValue } from "jotai";
import { FunctionalComponent } from "preact";

import { Icon } from "@/icons";
import { Card, Heading, Link, Text, TextButton } from "@/uikit";

import { earnApyAtom } from "@/api/earn";
import { useAccount } from "@/hooks/useAccount";
import { useCurrency } from "@/hooks/useCurrency";
import { useNavigation } from "@/hooks/useNavigation";
import { getOfferDomain } from "@/pages/Earn";
import { offers } from "@/pages/Earn/offers";
import { ModalControls } from "@/uikit/Modal";
import { formatAmount, formatNumber } from "@/utils/numbers";

type StakeSuccessProps = {
  amount: Big;
  controls: ModalControls;
};

export const StakeSuccessModal: FunctionalComponent<StakeSuccessProps> = (
  { amount, controls },
) => {
  const account = useAccount();
  const { navigate } = useNavigation();
  const currency = useCurrency();
  const apyData = useAtomValue(earnApyAtom);

  if (!account.connected) {
    return <></>;
  }

  const header = (
    <div className="stake-success-header gap-horizontal" data-success={true}>
      <div className="stake-modal-result-icon">
        <Icon iconKey="tick" />
      </div>
      <div>
        <Text variant="h3" weight="semibold">
          Success
        </Text>
        <Text className="description">
          Your{" "}
          <Text embed weight="semibold">
            {formatNumber(amount)} TON
          </Text>{" "}
          has been staked.{" "}
          <Link
            href={`${import.meta.env.VITE_EXPLORER_URL}${account.address}`}
            className="explorer-link"
            data-type="secondary"
          >
            View&nbsp;explorer
          </Link>
        </Text>
      </div>
    </div>
  );

  const offerAPYs = offers.map((offer) => getOfferApy(offer.sections, apyData));

  const offerRewards = offerAPYs.map((apy) => amount.mul(apy.div(100)));

  return (
    <>
      {header}

      <div className="stake-success-content gap-vertical">
        <Heading level={1}>
          You got{" "}
          {formatAmount({
            amount: currency.convert(amount, "tsTON", "TON"),
            currency: "tsTON",
            fracDigits: 2,
            tonSuffix: false,
          })}{" "}
          for your{" "}
          {formatAmount({
            amount,
            currency: "TON",
            fracDigits: 2,
            tonSuffix: false,
          })}
        </Heading>
        <Text variant="body" className="stake-success-caption">
          Earn More with Tonstakers tsTON
        </Text>
        {offers.map((offer, i) => {
          return (
            <Card
              className="stake-success-offer"
              onClick={() => {
                navigate("earn", getOfferDomain(offer));
                controls.close();
              }}
            >
              <div class="gap-vertical">
                <Text weight="semibold">{offer.name}</Text>
                <Text className="stonks">
                  Up to {formatNumber(offerAPYs[i], false, 2, false)}%
                </Text>
                <Text>
                  Earn{" "}
                  {formatAmount({
                    amount: offerRewards[i],
                    currency: "TON",
                    fracDigits: 2,
                    stripZeros: false,
                  })}{" "}
                  more
                </Text>
              </div>
              <img src={offer.icon} />
            </Card>
          );
        })}
      </div>
      <div className="stake-modal-result-buttons gap-vertical">
        <TextButton
          onClick={() => {
            navigate("stake");
            controls.close();
          }}
        >
          Stake more
        </TextButton>
      </div>
    </>
  );
};
